import { Direction, useMediaQuery, Grid, Box } from '@mui/material';
import {
  CcfCalendarIcon,
  CcfHeader,
  CcfTabs,
  CcfTypography,
  useTranslator,
} from '@nice-ccf/ui-controls';
import { useSelector } from 'react-redux';
import { Calander } from '../../enums/calendar-tabs';
import { getApplicationDirection } from '../global.app.slice';
import SchedulerLargeView from './ccf-schedular-large-view';
import ccfAppSchedulerStyles from './ccf-app-schedule.styles';
import { CcfCommitmentsForm } from '../ccf-commitment/ccf-commitment-form';
import { getShowCommitmentFormState } from '../ccf-commitment/ccf-commitment.slice';
import { getNewCommitment } from '../ccf-inbox/ccf-inbox.slice';
import CcfScheduleNewCommitment from '../ccf-schedule-new-commitment/ccf-schedule-new-commitment';
import { Theme, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';

/* eslint-disable-next-line */
export interface CcfAppScheduleProps {
  isfullView?: boolean;
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    scheduleHeader: {
      background: `${theme.palette.background.level1} 0% 0% no-repeat padding-box`,
      borderRadius: '5px 5px 0px 0px',
      opacity: 1,
      display: 'flex',
      alignItems: 'center',
      paddingTop: '10px',
      paddingBottom: '10px',
      paddingLeft: '5px',
      marginTop: '0px !important',
      '& section': {
        marginBottom: '0px !important',
        alignItems: 'center',
      },
      '& > div': {
        marginTop: '0px !important',
      },
      '& label': {
        color: theme.palette.text.secondary,
        marginLeft: '4px !important',
        marginTop: '0px !important',
        fontWeight: 'bold',
        lineHeight: '1',
      },
      '& svg': {
        verticalAlign: 'middle',
      },
    },
  })
);

interface CalendarTab {
  element: React.ReactElement;
  label: string;
  isActive: boolean;
}
/**
 * Schedule to be shown in CXone and IA. App scape has a different container
 * @example `<CcfAppSchedule />`
 */
export function CcfAppSchedule(props?: CcfAppScheduleProps) {
  const isNewCommitment = useSelector(getNewCommitment);
  const classes = useStyles();
  const appDirection: Direction = useSelector(getApplicationDirection);
  const [translate] = useTranslator();
  const theme = useTheme();
  const isSmView = useMediaQuery(theme.breakpoints.down('xl'));
  const calendarTabs: CalendarTab[] = [
    {
      element: <SchedulerLargeView isfullView={props?.isfullView} />,
      isActive: true,
      label: translate(Calander.MY_SCHEDULE),
    },
  ];

  const activeTabs = calendarTabs.filter((tab) => tab.isActive);
  const schedulerStyles = ccfAppSchedulerStyles(theme, isSmView);
  const showCommitmentForm = useSelector(getShowCommitmentFormState);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {isNewCommitment ? (
        <CcfScheduleNewCommitment />
      ) : (
        <Grid sx={schedulerStyles.calendarCardStyles as any}>
          {!isSmView && props?.isfullView && (
            <Grid className={classes.scheduleHeader}>
              <CcfHeader
                LeftIcon={
                  <CcfCalendarIcon
                    color="primary"
                    viewBox="-2 -2 23 23"
                    fontSize="small"
                  />
                }
                headerText={translate('schedule')}
                RightIcon={false}
                direction={appDirection}
              />
            </Grid>
          )}
          {showCommitmentForm ? (
            <CcfCommitmentsForm isFullView={true} />
          ) : props?.isfullView ? (
            <CcfTabs
              currentTab={0}
              variant={CcfTabs.Variant.STANDARD}
              setCurrentTab={() => null}
            >
              {activeTabs.map((tab, index) => (
                <CcfTabs.TabPanel key={index} label={tab.label}>
                  <Box sx={schedulerStyles.tabContentSection}>
                    {tab.element}
                  </Box>
                </CcfTabs.TabPanel>
              ))}
            </CcfTabs>
          ) : (
            <>
              <CcfTypography sx={schedulerStyles.txtMySchedule}>
                {translate('mySchedule')}
              </CcfTypography>
              <Box sx={schedulerStyles.tabContentSection}>
                <SchedulerLargeView isfullView={props?.isfullView} />
              </Box>
            </>
          )}
        </Grid>
      )}
    </>
  );
}

export default CcfAppSchedule;
